import type { ColumnDef } from '@tanstack/react-table';

import { multiSelectColumn, numberColumn, textColumn } from 'components/DataTable';

import {
    GetMealPlanDefinitionsQuery,
    MealPlanDefinitionState as MealPlanDefinitionStateEnum,
} from 'data/__generated__';

import { MealPlanDefinitionState, MEAL_PLAN_DEFINITION_STATE_LABELS } from '../components/MealPlanDefinitionState';

export type MealPlanDefinitionRow = GetMealPlanDefinitionsQuery['mealPlanDefinitions'][number];

type MealPlanDefinitionFilterInput = {
    searchValue: string;
    name: string;
    state: MealPlanDefinitionStateEnum[];
    numberOfSpots: number;
};

export const mealPlanDefinitionsColumns: ColumnDef<MealPlanDefinitionRow, unknown>[] = [
    textColumn<MealPlanDefinitionRow, MealPlanDefinitionFilterInput>({
        accessorKey: 'name',
        header: 'Nom',
        filterKey: 'name',
        defaultVisible: true,
    }),
    textColumn<MealPlanDefinitionRow, MealPlanDefinitionFilterInput>({
        id: 'hoursIntervalAvailable',
        accessorFn: (row) => row.hoursIntervalAvailable.join(' – '),
        header: 'Horaire de validité',
        defaultVisible: true,
    }),
    numberColumn<MealPlanDefinitionRow, MealPlanDefinitionFilterInput>({
        id: 'numberOfSpots',
        accessorFn: (row) => row.eligibleCategories.length,
        header: "Nombre d'emplacements",
        filterKey: 'numberOfSpots',
        defaultVisible: true,
    }),
    textColumn<MealPlanDefinitionRow, MealPlanDefinitionFilterInput>({
        id: 'discountRatios',
        // Les remises sont indexées par `nombre de produits - 2` : la première vaut pour deux produits.
        accessorFn: (row) =>
            row.discountRatios.map((ratio, index) => `${index + 2} → ${Math.round(ratio * 100)} %`).join(', '),
        header: 'Remises',
        defaultVisible: true,
    }),
    multiSelectColumn<MealPlanDefinitionRow, MealPlanDefinitionFilterInput>({
        accessorKey: 'state',
        header: 'Statut',
        filterKey: 'state',
        defaultVisible: true,
        defaultFilterValue: [MealPlanDefinitionStateEnum.Regular],
        options: Object.values(MealPlanDefinitionStateEnum).map((state) => ({
            value: state,
            label: MEAL_PLAN_DEFINITION_STATE_LABELS[state],
        })),
        renderOption: (option) => <MealPlanDefinitionState state={option.value as MealPlanDefinitionStateEnum} />,
        cell: ({ row }) => <MealPlanDefinitionState state={row.original.state} />,
    }),
];
